export enum Criterion {
    MM01 = 1,
    MM02 = 2,
    MM03 = 3,
    MM04 = 4,
    MM05 = 5,
    MM06 = 6,
    MM07 = 7,
    MM08 = 8,
    MM09 = 9,
    MM10 = 10,
    MM11 = 11,
    MM12 = 12,
    MM13 = 13
}
